var _templateObject = _taggedTemplateLiteralLoose(['\nmargin-right: 4px;\nmargin-left: 4px;\nmin-height: 28px;\nmargin-bottom: ', ';\nline-height: 32px;\nspan {\n  white-space: nowrap;\n}\n.danger {\n  span {\n    white-space: normal;\n  }\n}\n& > div div {\n  margin-bottom: 0px;\n}\n&.withmargin {\n  margin-bottom: 8px;\n  @media (max-width: 1024px) {\n    margin-bottom: 0px;\n  }\n}\nspan.withmargin {\n  margin-bottom: 8px;\n  display: inline-block;\n}\n@media (max-width: 1024px) {\n  text-align: center;\n}\n'], ['\nmargin-right: 4px;\nmargin-left: 4px;\nmin-height: 28px;\nmargin-bottom: ', ';\nline-height: 32px;\nspan {\n  white-space: nowrap;\n}\n.danger {\n  span {\n    white-space: normal;\n  }\n}\n& > div div {\n  margin-bottom: 0px;\n}\n&.withmargin {\n  margin-bottom: 8px;\n  @media (max-width: 1024px) {\n    margin-bottom: 0px;\n  }\n}\nspan.withmargin {\n  margin-bottom: 8px;\n  display: inline-block;\n}\n@media (max-width: 1024px) {\n  text-align: center;\n}\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Text = styled.label(_templateObject, function (props) {
  return props.nobottom ? '0px' : '8px';
});

var QQText = function QQText(props) {
  var nobottom = props.nobottom;
  return React.createElement(Text, {
    nobottom: nobottom
  }, props.children);
};

export default QQText;